import React from "react";
import { Toaster } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";

// Import pages directly instead of lazy loading
import Index from "./pages/Index";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Locations from "./pages/Locations";
import Services from "./pages/Services";

// Analytics tracking component
const AnalyticsTracker = () => {
  const location = useLocation();
  
  React.useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search
      });
      console.info('Analytics: Pageview tracked -', location.pathname);
    }
  }, [location]);
  
  return null;
};

// Separate component for routes to ensure proper context usage
const AppContent = () => {
  // Log app initialization - moved here from App component
  React.useEffect(() => {
    console.info('App component mounted');
  }, []);

  return (
    <div className="min-h-screen flex flex-col pt-24">
      <AnalyticsTracker />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/services" element={<Services />} />
        </Routes>
      </main>
    </div>
  );
};

// Main App component
const App = () => {
  // Create the QueryClient instance
  const [queryClient] = React.useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000,
      },
    },
  }));

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <Toaster />
          <AppContent />
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  );
};

export default App;
